var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"buttons buttons--add",on:{"click":function($event){return _vm.$emit('close-order')}}},[_vm._v(" "+_vm._s(_vm.$t('global:close'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }